const PageLoader = ({ label = "Loading module..." }) => (
  <div className="flex items-center justify-center p-10 text-gray-400">
    <div className="animate-pulse">{label}</div>
  </div>
);

export default PageLoader;
